module.exports = __webpack_public_path__ + "static/index/img/baikal-702.2e9b3bda.jpg";